import React from 'react';
import PropTypes from 'prop-types';

import CookieService from '../../services/CookieService';

class Stats extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stats: {
                be: '',
                brussels: '',
                vlaanderen: '',
            },
        };

        this.langcode = CookieService.get('DNSBELGIUM_LANGUAGE');
    }

    componentDidMount = () => {
        this.search();
    };

    search = async () => {
        await window.stats;

        this.setState({
            stats: window.stats,
        });
    };

    render = () => {
        const {
            stats,
        } = this.state;

        const {
            value,
            extension,
        } = this.props;

        const stat = stats[extension] ?
            stats[extension].total.toLocaleString(this.langcode) :
            value.toLocaleString(this.langcode);

        return stat;
    };
}

Stats.propTypes = {
    value: PropTypes.string.isRequired,
    extension: PropTypes.string.isRequired,
};

export default Stats;
